import { calcDeduzioneNottePassiva } from '../components/Turni/nottePassiva';
import { calcDuration } from './turniStats';

export const ABSENCE_TYPES = ['ferie', 'permesso', 'malattia'];

const MESI_IT = ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'];

export const fmt = (dateStr) => {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-');
  return `${d}/${m}/${y}`;
};

export const italianWeekday = (fullDate) => {
  const d = new Date(`${fullDate}T12:00:00`);
  const name = d.toLocaleDateString('it-IT', { weekday: 'long' });
  return name.charAt(0).toUpperCase() + name.slice(1);
};

export const fmtDuration = (hours) => {
  if (!hours || hours <= 0) return '';
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  return m === 0 ? `${h}h` : `${h}h ${m}m`;
};

export const absenceLabel = (type) => {
  if (type === 'malattia') return 'Malattia';
  if (type === 'permesso') return 'Permesso';
  return 'Ferie';
};

export const monthLabel = (fullDate) => {
  if (!fullDate) return '';
  const [y, m] = fullDate.split('-');
  return `${MESI_IT[parseInt(m, 10) - 1]} ${y}`;
};

const buildLeaveRow = (date, giorno, leave) => {
  const type = (leave.leave_type || 'ferie').toLowerCase();
  const timeRange = leave.start_time && leave.start_time.substring(0, 5) !== '00:00' && leave.end_time
    ? ` ${leave.start_time.substring(0, 5)}-${leave.end_time.substring(0, 5)}` : '';
  return [date, giorno, `${absenceLabel(type)}${timeRange}`, '', leave.motivazione || '', ''];
};

const buildShiftLines = (shifts, dayReps) => {
  const lines = shifts.map(s => {
    if (ABSENCE_TYPES.includes(s.shift_type)) {
      const timeRange = s.start_time && s.start_time.substring(0, 5) !== '00:00' && s.end_time
        ? ` ${s.start_time.substring(0, 5)}-${s.end_time.substring(0, 5)}` : '';
      return absenceLabel(s.shift_type) + timeRange;
    }
    const start = s.start_time ? s.start_time.substring(0, 5) : '?';
    const end = s.end_time ? s.end_time.substring(0, 5) : '?';
    const period = s.shift_period === 'giorno' ? ' [G]' : s.shift_period === 'notte' ? ' [N]' : s.shift_period === 'coda_della_notte' ? ' [C]' : '';
    return `${start}-${end}${period}${parseInt(s.is_overtime, 10) === 1 ? ' (Str.)' : ''}`;
  });
  dayReps.forEach(r => {
    const start = r.start_time ? r.start_time.substring(0, 5) : '?';
    const end = r.end_time ? r.end_time.substring(0, 5) : '?';
    lines.push(`Rep: ${start}-${end} ${r.period === 'notte' ? '[N]' : '[G]'}`);
  });
  return lines;
};

const buildShiftRow = (date, giorno, shifts, dayReps) => {
  const lines = buildShiftLines(shifts, dayReps);
  const allAbsences = shifts.every(s => ABSENCE_TYPES.includes(s.shift_type));
  const stato = allAbsences ? '' : shifts.some(s => s.status === 'timbrato') ? 'Timbrato' : 'Da timbrare';
  const firstNote = shifts[0]?.notes && String(shifts[0].notes).trim() !== '' && String(shifts[0].notes) !== '0'
    ? String(shifts[0].notes) : '';
  const totalWorked = shifts.filter(s => !ABSENCE_TYPES.includes(s.shift_type)).reduce((acc, s) => {
    const dur = calcDuration(s.start_time, s.end_time);
    return acc + (s.status === 'timbrato' ? dur - calcDeduzioneNottePassiva(s) : dur);
  }, 0);
  return [date, giorno, lines.join('\n'), fmtDuration(totalWorked), firstNote, stato];
};

export const buildDayRows = (allDays, turniData, managerFerieList, uName, reperibilitaData = []) =>
  allDays.map(d => {
    const date = fmt(d.fullDate);
    const giorno = italianWeekday(d.fullDate);
    const leave = managerFerieList.find(lv => lv.operator_name === uName && lv.status === 'approvata' && lv.start_date <= d.fullDate && lv.end_date >= d.fullDate);
    if (leave) return buildLeaveRow(date, giorno, leave);
    const shifts = turniData.filter(t => t.operator_name === uName && t.date === d.fullDate);
    const dayReps = reperibilitaData.filter(r => r.operator_name === uName && r.date === d.fullDate);
    if (shifts.length === 0 && dayReps.length === 0) return [date, giorno, 'Riposo', '', '', ''];
    return buildShiftRow(date, giorno, shifts, dayReps);
  });
